module.exports = __webpack_public_path__ + "img/XVI-logo-anio2-gris-2020.d58755d0.svg";